var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.01758 1.125C8.86114 1.125 8.70469 1.18477 8.58692 1.30254L5.84825 4.04297C5.6127 4.28027 5.6127 4.66523 5.85001 4.90254C6.08555 5.13984 6.47051 5.13984 6.70782 4.90254L8.41114 3.19922V13.3559C8.41114 13.6916 8.6836 13.9641 9.01934 13.9641C9.35508 13.9641 9.62754 13.6916 9.62754 13.3559V3.19922L11.3309 4.90254C11.4451 5.0168 11.5981 5.08008 11.7598 5.08008C11.9215 5.08008 12.0744 5.0168 12.1887 4.90254C12.426 4.66523 12.426 4.28027 12.1887 4.04297L9.44825 1.30254C9.32872 1.18477 9.17403 1.125 9.01758 1.125ZM15.6586 11.8658C15.6586 11.5301 15.9311 11.2576 16.2668 11.2576C16.6025 11.2576 16.875 11.5301 16.875 11.8641V15.7822C16.875 16.3834 16.3863 16.8738 15.7834 16.8738H2.2166C1.61543 16.8738 1.125 16.3852 1.125 15.7822V11.8641C1.125 11.5301 1.3957 11.2559 1.73145 11.2559C2.06719 11.2559 2.33965 11.5283 2.33965 11.8641V15.3006C2.33965 15.501 2.50313 15.6627 2.70176 15.6627H15.2965C15.4969 15.6627 15.6586 15.4992 15.6586 15.3006V11.8658Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.de4b9ec4.svg";
export { ForwardRef as ReactComponent };